import { solidstate } from ":setup/qstate";
import DefaultLayout from "../SHARED/layouts/default-layout";
import * as certificate from "./apis/certificate";
import AcceptDetails from "./components/certificate-details";
import type { CertificateDetails } from "./_model";

export default function Certificate() {
  const $details = solidstate.create(null as CertificateDetails);
  return (
    <DefaultLayout
      //
      // debug
      api={certificate.get}
      onValid={(details) => {
        $details.set(details);
      }}
    >
      <AcceptDetails details={$details.value} />
    </DefaultLayout>
  );
}
